class recentlyProducts extends HTMLElement {
    constructor() {
      super();
      this.recentlyViewed = [];
      this.container = document.querySelector('.recently-viewed-main');
      this.manageRecentlyViewed();      
    }
    
    manageRecentlyViewed(){
      let getRecentlyViewed = localStorage.getItem("user_recently_viewed");
      if (getRecentlyViewed != null) {
        this.recentlyViewed = JSON.parse(getRecentlyViewed);        
        this.recentlyViewed.reverse();

        if(this.recentlyViewed.length > 0) this.showRecentlyViewed(this.recentlyViewed);
      }
      
      if(window.globalVariables.template == 'product'){
        const productData = window.globalVariables.product;
        let requiredData = {
          id: productData.id,
          handle: productData.handle,
          title: productData.title,
          price: productData.price,
          compared_at_price: productData.compare_at_price,
          productminprice:productData.price_min,
          productMaxprice:productData.price_max,
          image: productData.featured_image
        }
        this.addToRecentlyViewed(requiredData);
      }
    }

    showRecentlyViewed(products) {
      let recentlyViewedHTML = '';
      let totalProducts = 0;
      products.forEach(product => {
        const currentIndex = product.id == window.globalVariables.product.id;
        let priceHTML='';
        if(product.productminprice != null && product.productMaxprice !=null && product.compared_at_price == null){
          priceHTML= `<span class="price m-0 p-0 money opacity-07 fs-sm" data-currentprice="">${Utility.formatMoney(product.productminprice, window.globalVariables.money_format)} - ${Utility.formatMoney(product.productMaxprice, window.globalVariables.money_format)}</span>`
        }
        else{
          if (product.compared_at_price != null) {
            priceHTML= `<span class="price m-0 p-0 fs-sm fw-semibold opacity-07"><del class="price small m-0 p-0 me-1 money d-inline-block opacity-05" data-compareprice="">${Utility.formatMoney(product.compared_at_price, window.globalVariables.money_format)}</del> ${Utility.formatMoney(product.price, window.globalVariables.money_format)}</span>`  
          }else{
            priceHTML= `<span class="price m-0 p-0 fs-sm fw-semibold opacity-07">${Utility.formatMoney(product.price, window.globalVariables.money_format)}</span>`  
          }
        }
        
        if(currentIndex == false){
          totalProducts += 1;
          if (totalProducts <= 10) {
            console.log(totalProducts);
            recentlyViewedHTML += ` <div class="swiper-slide">
            <div class="card card-product card-product-style-1 text-start rounded-0 border-0">
              <div class="card-img text-center border-0">
              <a href="/products/${product.handle}" class="d-block product-link position-relative">
              <img src="${product.image}" alt="${product.title}"></a>
              </div>
              <div class="card-body bg-white ps-0 pe-0">
                <a href="/products/${product.handle}" class="product-link lh-base text-primary hover-opacity"><h6 class="fs-md card-title m-0 fw-normal ">${product.title}</h6></a>
                ${priceHTML}
              </div>
            </div>
          </div>`;  
          }
        }
      });

      if(totalProducts > 0){
        let sliderHTML = `<slider-element class="swiper-container carousel">
            <div class="swiper swiper-slider card-carousel" data-slider='{
              "loop": false,
              "threshold": 20,
              "slidesPerView": "2",
              "spaceBetween": 15,
              "grabCursor": true,
              "pagination": {
                "el": ".swiper-pagination",
                "clickable": true
            },
              "breakpoints": {
              "560": {
                  "slidesPerView": 2,
                  "spaceBetween": 20
              },
              "768": {
                  "slidesPerView": 3,
                  "spaceBetween": 15
              },
              "992": {
                  "slidesPerView": 4,
                  "spaceBetween": 20
              },
              "1200": {
                "slidesPerView": 5,
                "spaceBetween": 30
              }
            }
          }'>
            <div class="swiper-wrapper">${recentlyViewedHTML}</div>
            <div class="swiper-pagination position-relative mt-4"></div>
          </div>
        </slider-element>`;
        if (this.container) {
          this.container.classList.remove('d-none');
          this.container.querySelector("recently-products").innerHTML = sliderHTML;         
        }
      }      
    }

    addToRecentlyViewed(product) {
      const productExist = this.recentlyViewed.findIndex((x) => {
        return x.id == product.id;
      });

      if (productExist == -1) {
        this.recentlyViewed.push(product)
        localStorage.setItem(
          "user_recently_viewed",
          JSON.stringify(this.recentlyViewed)
        );
      }
    }
}
customElements.define("recently-products", recentlyProducts);

